import classNames from "classnames";

function TimelineBox({ className, timelineBoxData }) {
  return (
    <div
      className={classNames(
        "pl-timeline-box text-white pl-3 pt-1.5 flex flex-col relative",
        className
      )}
    >
      <div className="text-lg">{timelineBoxData.title}</div>
      {timelineBoxData.org && (
        <div className="text-xs mt-0.5">@ {timelineBoxData.org}</div>
      )}
      <div className="text-xs">{timelineBoxData.date}</div>
      <div className="text-xs mt-3 flex flex-col justify-end mb-2">
        {timelineBoxData.desc}
      </div>
      {timelineBoxData.link && (
        <div className="absolute top-2 right-2">
          <a href={timelineBoxData.link} target="_blank" rel="noreferrer">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="stroke-white active:stroke-[#ff005c] transition-[stroke]"
            >
              <path
                d="M12.25 8.5V13C12.25 13.3978 12.092 13.7794 11.8107 14.0607C11.5294 14.342 11.1478 14.5 10.75 14.5H2.5C2.10218 14.5 1.72064 14.342 1.43934 14.0607C1.15804 13.7794 1 13.3978 1 13V4.75C1 4.35218 1.15804 3.97064 1.43934 3.68934C1.72064 3.40804 2.10218 3.25 2.5 3.25H7M10 1H14.5M14.5 1V5.5M14.5 1L6.25 9.25"
                className="stroke-inherit"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      )}
    </div>
  );
}

export default TimelineBox;
